import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/famamobile.webp';

const Famamobile = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="famamobile"
            logo={logo}
            primaryColor="#00A8CC"
            secondaryColor="#0A9D0E"
        />
    );
};

export default Famamobile;
